import type {
  CourseInviteTarget,
  PracticeInviteTarget,
  ProgramInviteTarget,
} from '../../../../modules/invites/stores/types';
import type {InviteTarget} from '../types';
import type {SendInvitesStrategy} from './SendInvitesStrategy';
import type {SendInvitesParams} from './types';

import {getEntityTypeById} from '../../../../utils/entity/getEntityType';
import {AppError} from '../../../../utils/errors/app';
import {SendInvitesToCourseStrategy} from './SendInvitesToCourseStrategy';
import {SendInvitesToPracticeStrategy} from './SendInvitesToPracticeStrategy';
import {SendInvitesToProgramStrategy} from './SendInvitesToProgramStrategy';

export class SendInvitesStrategyFactory {
  static createStrategy(
    target: InviteTarget,
    params: SendInvitesParams,
  ): SendInvitesStrategy {
    const entityType = getEntityTypeById(target._id);

    switch (entityType) {
      case 'course':
        return new SendInvitesToCourseStrategy(
          target as CourseInviteTarget,
          params,
        );
      case 'program':
        return new SendInvitesToProgramStrategy(
          target as ProgramInviteTarget,
          params,
        );
      case 'user':
        return new SendInvitesToPracticeStrategy(
          target as PracticeInviteTarget,
          params,
        );
      default:
        throw new AppError(`Unknown invite target entity type: ${entityType}`);
    }
  }
}
